import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../Common/FormValidation";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    date: new Date().toISOString().slice(0, 10),
    distributor_id: "",
  });
  const [error, setError] = useState({});
  const [receiptNo, setReceiptNo] = useState("");
  const [distributors, setDistributors] = useState([]);
  // Invoices of the chosen distributor that have not been merged yet.
  const [orders, setOrders] = useState([]);
  const [selected, setSelected] = useState([]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Default Load
  const fetchData = () => {
    Http.get("/distributor2").then((res) => {
      setDistributors(res.data);
    });
    Http.get("/merge-invoice-last-receipt-no").then((res) => {
      setReceiptNo(res.data);
    });
  };
  useEffect(() => {
    fetchData();
  }, []);
  // End Default Load

  const handleDistributorChange = (e) => {
    const value = e.target.value;
    setInputs((values) => ({ ...values, distributor_id: value }));
    setSelected([]);
    if (!value) return setOrders([]);
    Http.get("/merge-invoice-unmerged-orders/" + value).then((res) => {
      setOrders(res.data);
    });
  };

  const toggleOrder = (id) => {
    setSelected((current) => (current.includes(id) ? current.filter((item) => item !== id) : [...current, id]));
  };

  const toggleAll = (e) => {
    setSelected(e.target.checked ? orders.map((item) => item.id) : []);
  };

  const formSubmit = () => {
    if (selected.length < 1) {
      return setError({ orders: ["Please select at least one Invoice to merge."] });
    }

    const payload = { ...inputs, orders: selected };

    Http.post("/merge-invoice", payload)
      .then((res) => {
        navigate("/merge-invoice", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors ? e.response.data.errors : { message: [e.response.data.message] });
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Merge Invoice</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Merge Invoice Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>

            <div className="row">
              <div className="col-lg">
                <label>Merge No</label>
                <input type="text" className="form-control" value={receiptNo || ""} readOnly />
              </div>
              <div className="col-lg">
                <label>
                  Date <i className="fa fa-star required"></i>
                </label>
                <input type="date" className="form-control" name="date" value={inputs.date || ""} onChange={handleChange} />
              </div>
              <div className="col-lg">
                <label>
                  Distributor <i className="fa fa-star required"></i>
                </label>
                <select className="form-control" name="distributor_id" value={inputs.distributor_id || ""} onChange={handleDistributorChange}>
                  <option value="">Select Distributor</option>
                  {Array.from(distributors).map((item) => (
                    <option value={item.value} key={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>Vehicle Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="vehicle_number"
                  placeholder="Insert Vehicle Number"
                  value={inputs.vehicle_number || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mt-3">
              <table className="table table-sm align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                      <input type="checkbox" onChange={toggleAll} checked={orders.length > 0 && selected.length === orders.length} />
                    </th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">Invoice No</th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">Date</th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length < 1 ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        {inputs.distributor_id ? "No unmerged Invoice found for this Distributor." : "Select a Distributor to load its Invoices."}
                      </td>
                    </tr>
                  ) : (
                    Array.from(orders).map((item) => (
                      <tr key={item.id}>
                        <td>
                          <input type="checkbox" checked={selected.includes(item.id)} onChange={() => toggleOrder(item.id)} />
                        </td>
                        <td>{item.receipt_no}</td>
                        <td>{item.date}</td>
                        <td align="right">{item.total_price}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="row mt-3">
              <div className="col-9"></div>
              <div className="col-3">
                <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                  <i className="fa fa-send mg-r-10"></i> Merge
                </button>
              </div>
            </div>
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
